import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

import { ConsolidateOrdersForm } from './../consolidate/ConsolidateOrdersForm';
import {
  getConsolidateOrderDetail,
  emptyGridConsolidateData,
  setConsolidateApiModelData,
  processConsolidateOrder,
  clearProcessSubmitError,
  clearOrderConsolidatedVerificationMsg,
} from './../../state/consolidate/actions';
import { ConsolidateEnum, ItemEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { getSiteList } from '../../state/manageProcessOrder/actions';
import { LoadingPage, DirtyWrapper } from 'Components';
import { Main, Filter } from 'Containers';
import { CONSOLIDATE_FORM_NAME } from 'Common/FormEnum';
import { resetForm, submitForm } from 'State/forms/actions';
import { formValueSelector } from 'redux-form';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import 'Styles/pages/inventory/manageprocessorder/index.less';
import { ItemStatusEnum } from 'Common/Constants/Enumeration/Consolidate';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { clearTableSavedState } from 'Common/FormHelper';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { basicURL } from '../../helper';

class ConsolidateOrdersFormContainer extends Component {
  static path = '/manageprocessorder/consolidate/:SiteId';
  state = {
    showDialog: false,
    showWHAssociationDialog: false,
    whAssociationMessage: '',
    showNotQualified: false,
  };
  componentDidMount() {
    const {
      consolidateApiModel,
      getConsolidateOrderDetail,
      history,
      getSiteList,
    } = this.props;
    this.resetScroll();
    getSiteList();
    consolidateApiModel
      ? getConsolidateOrderDetail(consolidateApiModel).then(
          this.setWHAssociationDailoge
        )
      : history.push('/manageprocessorder');
  }
  componentWillUnmount() {
    this.props.resetForm(CONSOLIDATE_FORM_NAME);
    this.props.emptyGridConsolidateData();
    this.props.setConsolidateApiModelData(null);
    this.clearTableSavedState();
  }

  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, basicURL, allTableStates, setTableStates, [
      TableNamesEnum.MANAGE_PROCESS_ORDER_ITEM_TABLE,
      TableNamesEnum.MANAGE_PROCESS_ORDER_ITEM_CREATE_EDIT_TABLE,
    ]);
  };
  componentDidUpdate(prevProps) {
    const { clearProcessSubmitError } = this.props;
    if (
      errorToast(this.props, prevProps, 'consolidateDataError') ||
      errorToast(this.props, prevProps, 'consolidateProcessError')
    ) {
      clearProcessSubmitError();
    } else if (this.props.submitted && !prevProps.submitted) {
      createToast(toastType.success, 'Success', 'Order has been saved', true);

      clearProcessSubmitError();
    }
  }
  getBreadCrumbs = () => {
    const breadcrumbs = [
      {
        title: 'Consolidate Orders',
      },
    ];
    return breadcrumbs;
  };
  getRootUrl = () => {
    return '/manageprocessorder';
  };
  getMainProps = showDirtyConfirm => {
    return {
      toolbox: {
        backButtonProps: {
          shown: true,
          path: this.getRootUrl(),
        },
        rightButtons: [
          {
            content: 'Process',
            onClick: this.onProcessClick,
          },
        ],
        shown: true,
      },
    };
  };
  onSubmitClick = result => {
    if (result) {
      this.props.submitForm(CONSOLIDATE_FORM_NAME);
    }
    this.setState({ showDialog: false });
  };
  onProcessClick = () => {
    const { consolidateData } = this.props;
    if (
      consolidateData &&
      consolidateData[ConsolidateEnum.ConsolidateManagerModel]
    ) {
      const isQualified = consolidateData[
        ConsolidateEnum.ConsolidateManagerModel
      ].some(item => {
        return item[ItemEnum.ItemStatus] === ItemStatusEnum.ITEMS_QUALIFIED;
      });
      isQualified
        ? this.setState({ showDialog: isQualified })
        : this.setState({ showNotQualified: true });
    }
  };
  onCancelClick = () => {
    this.props.history.push('/manageprocessorder');
  };
  onSiteAndDeliveryDateChange = valueObj => {
    const {
      consolidateApiModel,
      getConsolidateOrderDetail,
      deliveryDate,
      siteId,
    } = this.props;
    const model = {
      ...consolidateApiModel,
      DeliveryDate: deliveryDate,
      SiteId: siteId,
      ...valueObj,
    };
    getConsolidateOrderDetail(model).then(this.setWHAssociationDailoge);
  };
  handleSubmit = values => {
    const { consolidateApiModel, processConsolidateOrder } = this.props;
    const model = { ...consolidateApiModel, ...values };
    delete model[ConsolidateEnum.OrderDT];
    this.resetScroll();
    processConsolidateOrder(model, this.redirectToRootPage);
  };
  resetScroll = () => this.props.scrollMainTo(0, 0);
  redirectToRootPage = () => {
    this.props.history.replace(this.getRootUrl());
  };
  setWHAssociationDailoge = () => {
    const { consolidateData } = this.props;
    let message =
      'The selected Site/Warehouse is not associated with the following Sites:' +
      '\n';
    let show = false;
    if (consolidateData && consolidateData[ConsolidateEnum.WHAssociation]) {
      const { WHAssociation } = consolidateData;
      _.forEach(WHAssociation, item => {
        if (!item[ConsolidateEnum.IsAssocationExists]) {
          show = true;
          message += item[ConsolidateEnum.SiteIdDestinationName] + '\n';
        }
      });
    }
    message +=
      '\nAfter Process, the selected Site/Warehouse will be associated.';
    this.setState({
      showWHAssociationDialog: show,
      whAssociationMessage: message,
    });
  };
  showWHAssociationDialogOkClick = () => {
    this.setState({ showWHAssociationDialog: false });
  };
  showNotQualifiedOkClick = () => {
    this.setState({ showNotQualified: false });
  };
  getYesNoDialogMsg = () => {
    const { consolidateData } = this.props;
    let msg = 'Do you want to process consolidate orders?';
    if (
      consolidateData &&
      consolidateData[ConsolidateEnum.OrderConsolidatedVerificationModel] &&
      consolidateData[ConsolidateEnum.OrderConsolidatedVerificationModel][
        ConsolidateEnum.ConsolidatedOrderId
      ] &&
      consolidateData[ConsolidateEnum.OrderConsolidatedVerificationModel][
        ConsolidateEnum.OriginalOrderId
      ]
    ) {
      msg = 'The following orders have already been consolidated! \n';
      msg +=
        'Order ' +
        consolidateData[ConsolidateEnum.OrderConsolidatedVerificationModel][
          ConsolidateEnum.ConsolidatedOrderId
        ] +
        ' was created from order ' +
        consolidateData[ConsolidateEnum.OrderConsolidatedVerificationModel][
          ConsolidateEnum.OriginalOrderId
        ] +
        '\n\n';
      msg += 'Do you want to continue with order consolidation?';
    }

    return msg;
  };
  render() {
    const { SiteId } = this.props.match.params;
    const {
      fetchingDropDown,
      consolidateDataLoading,
      isReadOnly,
      sitesData,
      consolidateProcessLoading,
    } = this.props;
    const momentDate = moment();
    return (
      <Fragment>
        {(fetchingDropDown ||
          consolidateDataLoading ||
          consolidateProcessLoading) && <LoadingPage />}
        <Filter title={''} breadcrumbs={this.getBreadCrumbs()} />
        <DirtyWrapper
          closeModalYesCallback={this.onCancelClick}
          isReadOnly={isReadOnly}
        >
          {showDirtyConfirm => (
            <Main
              {...this.getMainProps(showDirtyConfirm)}
              shouldNotUsePageWidth
            >
              <ConsolidateOrdersForm
                consolidateData={this.props.consolidateData}
                sitesData={sitesData}
                onSiteAndDeliveryDateChange={this.onSiteAndDeliveryDateChange}
                initialValues={{
                  [ConsolidateEnum.OrderDT]: momentDate.format(
                    DATE_FORMAT_FOR_UI
                  ),
                  [ConsolidateEnum.DeliveryDate]: momentDate.format(
                    DATE_FORMAT_FOR_UI
                  ),
                  [ConsolidateEnum.SiteId]: SiteId,
                }}
                onSubmit={this.handleSubmit}
                onSubmitClick={this.onSubmitClick}
                showDialog={this.state.showDialog}
                showWHAssociationDialog={this.state.showWHAssociationDialog}
                whAssociationMessage={this.state.whAssociationMessage}
                showWHAssociationDialogOkClick={
                  this.showWHAssociationDialogOkClick
                }
                showNotQualified={this.state.showNotQualified}
                showNotQualifiedOkClick={this.showNotQualifiedOkClick}
                getYesNoDialogMsg={this.getYesNoDialogMsg}
                redirectToRootPage={this.redirectToRootPage}
                clearOrderConsolidatedVerificationMsg={
                  this.props.clearOrderConsolidatedVerificationMsg
                }
              />
            </Main>
          )}
        </DirtyWrapper>
      </Fragment>
    );
  }
}

const selector = formValueSelector(CONSOLIDATE_FORM_NAME);
const mapStateToProps = (state, props) => {
  const {
    SiteSetupState: { assignItems },
    ManageOrderItemState: { consolidate, manageProcessOrder },
  } = state;

  return {
    consolidateApiModel: consolidate.consolidateApiModel,
    consolidateData: consolidate.consolidateData,
    fetchingDropDown: assignItems.loading,
    fetchingSites: manageProcessOrder.fetchingSites,
    consolidateDataLoading: consolidate.consolidateDataLoading,
    sitesData: manageProcessOrder.siteListData,
    deliveryDate: selector(state, ConsolidateEnum.DeliveryDate),
    siteId: selector(state, ConsolidateEnum.SiteId),
    consolidateProcessLoading: consolidate.consolidateProcessLoading,
    consolidateDataError: consolidate.consolidateDataError,
    consolidateProcessError: consolidate.consolidateProcessError,
    submitted: consolidate.submitted,
    allTableStates: getTableStates(state),
  };
};
export const ConsolidateOrders = connect(
  mapStateToProps,
  {
    getConsolidateOrderDetail,
    getSiteList,
    emptyGridConsolidateData,
    setConsolidateApiModelData,
    resetForm,
    processConsolidateOrder,
    submitForm,
    clearProcessSubmitError,
    clearOrderConsolidatedVerificationMsg,
    setTableStates,
  }
)(ConsolidateOrdersFormContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/containers/subpages/ConsolidateOrders.js